<template>
  <div class="freight-table-clients">
    <a-input-search
      v-model="search"
      placeholder="Busque pelo cliente"
      class="freight-table-clients__search"
      allow-clear
    />

    <a-empty v-if="!filtered.length" description="Nenhum cliente encontrado." />

    <BaseDataTable
      v-else
      :columns="columns"
      :items="filtered"
      :pagination="{ current: page, perPage, total: filtered.length }"
      @change="onTableChange"
    >
      <template slot="cliente" slot-scope="text, record">
        <div class="freight-table-clients__client">
          <span class="freight-table-clients__client-name" :title="record.nome">
            {{ record.nome }}
          </span>
          <span class="freight-table-clients__client-doc">
            {{ record.documento }}
          </span>
        </div>
      </template>
    </BaseDataTable>
  </div>
</template>

<script>
import BaseDataTable from "@/shared/components/BaseDataTable.vue";

// Só leitura: os clientes vêm na árvore da tabela, já filtrados nos vínculos ativos — os
// inativos de uma receita são as transportadoras da etapa Parceiro, não clientes.
export default {
  name: "FreightTableClientsTable",
  components: { BaseDataTable },
  props: {
    clients: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: "",
      page: 1,
      perPage: 10,
      columns: [
        {
          title: "Cliente",
          key: "cliente",
          scopedSlots: { customRender: "cliente" },
        },
        { title: "Município", dataIndex: "municipio", key: "municipio" },
        {
          title: "Inscrição estadual",
          dataIndex: "inscricaoEstadual",
          key: "inscricaoEstadual",
        },
      ],
    };
  },
  computed: {
    filtered() {
      const term = this.search.trim().toLowerCase();
      if (!term) return this.clients;
      return this.clients.filter((client) =>
        `${client.nome} ${client.documento}`.toLowerCase().includes(term),
      );
    },
  },
  watch: {
    search() {
      this.page = 1;
    },
  },
  methods: {
    onTableChange({ page, perPage }) {
      this.page = perPage !== this.perPage ? 1 : page;
      this.perPage = perPage;
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.freight-table-clients {
  &__search {
    max-width: 400px;
    margin-bottom: 16px;
  }

  &__client {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &__client-name {
    color: @color-text-dark;
    font-weight: 600;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__client-doc {
    font-size: 12px;
    color: @color-text-medium;
    margin-top: 2px;
  }
}
</style>
